module.exports = __webpack_public_path__ + "img/6-2.53a5a5a2.jpg";